import axiosInstance from '@/axiosInstance.ts'

interface SubmitLogData {
    entity_id?: number
    task_media_id?: string
    flow: string
    recap: string
    highlights: string
    ticket: boolean
    thread_id: string
}

export const httpSubmitLog = (data: SubmitLogData) => {
    const url = `/chatbot/logs`
    return axiosInstance.post(url, data)
}
